import { render } from "./PendingDownloadsIndicator.vue?vue&type=template&id=16a61205&scoped=true"
import script from "./PendingDownloadsIndicator.vue?vue&type=script&lang=js"
export * from "./PendingDownloadsIndicator.vue?vue&type=script&lang=js"

import "./PendingDownloadsIndicator.vue?vue&type=style&index=0&id=16a61205&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a61205"]])

export default __exports__